const initiationSearchKeysDict = {
    bookingName: 'Booking Number',
    clientName: 'Client Name',
    clinicianName: 'Clinician Name',
    collectorName: 'Collector Name',
    poNumber: 'PO Number',
};

const managementSearchKeysDict = {
    clientName: 'Client',
    customerNumber: 'Customer number',
    bookingNumber: 'Booking number',
    clinicianName: 'Clinician',
    invoiceNumber: 'Invoice number',
    collectorName: 'Collector',
    poNumber: 'PO',
};

export const initiationSearchOptions = Object.entries(initiationSearchKeysDict).map(
    ([key, name]) => ({
        name,
        value: key,
    })
);

export const managementSearchOptions = Object.entries(managementSearchKeysDict).map(
    ([key, name]) => ({
        name,
        value: key,
    })
);
